module.exports = __webpack_public_path__ + "static/media/countdown-edition-logo.51924b09.png";